import { Box, Button } from "@mui/material";
import { useReminderTypesQuery } from "web_myplann/Api/Reminders/useReminderTypesQuery";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ReminderFormFields } from "web_myplann/Reminders/Components/ReminderFormFields";
import { useReminderCreateForm } from "web_myplann/Reminders/Hooks/useReminderCreateForm";
import type { ReminderEntity } from "web_myplann/Reminders/Types/ReminderTypes";
import { SmallDrawer } from "web_myplann/Shared/Components/SmallDrawer";

type Props = {
	entity: ReminderEntity;
	open: boolean;
	onClose: () => void;
};

export const ReminderCreateDrawer = ({ entity, open, onClose }: Props) => {
	const { t } = useResource();

	const { data: templates = [] } = useReminderTypesQuery(entity);

	const { form, submit, isSubmitting } = useReminderCreateForm({
		entity,
		templates,
		onSuccess: onClose,
	});

	return (
		<SmallDrawer
			open={open}
			onClose={onClose}
			title={t(Resources.Reminders.Form.addTitle)}
		>
			<ReminderFormFields form={form} templates={templates} />

			<Box px={1.6} py={1.6}>
				<Button
					variant="primary"
					onClick={submit}
					disabled={!form.formState.isValid || isSubmitting}
				>
					{t(Resources.Reminders.Form.addCta)}
				</Button>
			</Box>
		</SmallDrawer>
	);
};
